import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Row } from 'react-styled-flexboxgrid'
import { DataSource, Markdown, Button } from '..'
import { Link } from 'gatsby'
import * as styles from './styles'

const propTypes = {
  useCase: PropTypes.object.isRequired,
  isReverse: PropTypes.bool,
}

const defaultProps = {
  isReverse: null
}

const UseCaseCard = (props) => {
  const { useCase, isReverse } = props
  const {
    title, description, benefit, browserContent, dataSources
  } = useCase

  return (
    <styles.UseCaseCardContainer>
      <Row reverse={isReverse}>
        <styles.UseCaseCol md={6} xs={12} lg={7}>
          <styles.UseCaseInfo>
            <styles.UseCaseCardHeader>
              {title}
            </styles.UseCaseCardHeader>
            <styles.UseCaseDescription>
              <Markdown>
                {description}
              </Markdown>
            </styles.UseCaseDescription>
            <styles.UseCaseBenefit>
              {benefit}
            </styles.UseCaseBenefit>

            <styles.UseCaseDataSource>
              <styles.DataSourceHeader>Data sources</styles.DataSourceHeader>
              <styles.DataSources>
                {_.map(dataSources, (dataSource, i) => {
                  return <DataSource key={i} iconSrc={dataSource.iconSrc} text={dataSource.text} />
                })}
              </styles.DataSources>
            </styles.UseCaseDataSource>

            <Link to="/request-trial">
              <Button size="small">
                Request access
              </Button>
            </Link>

          </styles.UseCaseInfo>
        </styles.UseCaseCol>

        <styles.UseCaseCol md={6} xs={12} lg={5}>
          {browserContent}
        </styles.UseCaseCol>
      </Row>
    </styles.UseCaseCardContainer>
  )
}

UseCaseCard.propTypes = propTypes
UseCaseCard.defaultProps = defaultProps

export default UseCaseCard
